import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M18.058 22.385H5.942a1.73 1.73 0 0 1-1.73-1.731V5.077h15.576v15.577a1.73 1.73 0 0 1-1.73 1.73Zm-8.654-5.193V10.27m5.192 6.922V10.27M.75 5.077h22.5m-8.654-3.462H9.404a1.73 1.73 0 0 0-1.73 1.731v1.73h8.653v-1.73a1.73 1.73 0 0 0-1.73-1.73Z"
    }, null, -1)
  ]));
}
const interfaceDeleteBinTrash = { render };
export {
  interfaceDeleteBinTrash as default,
  render
};
//# sourceMappingURL=interface-delete-bin-trash.svg.js.map
